/**
 * 钉钉 H5 微应用辅助
 * - 检测是否在钉钉容器内
 * - 在钉钉容器中获取 authCode
 * - 非钉钉容器时抛错，由上层降级到紧急登录
 */

export function isInDingTalk(): boolean {
  return /DingTalk/i.test(navigator.userAgent)
}

/** 等待 window.dd.ready，最多 maxWait 毫秒 */
function waitForDD(maxWait = 5000): Promise<NonNullable<Window['dd']>> {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const timer = setInterval(() => {
      if (window.dd) {
        clearInterval(timer)
        window.dd.ready(() => resolve(window.dd!))
      } else if (Date.now() - start > maxWait) {
        clearInterval(timer)
        reject(new Error('钉钉 JSAPI 未注入（可能不在钉钉容器内）'))
      }
    }, 100)
  })
}

/** 获取 authCode（需在钉钉容器内调用） */
export async function getAuthCode(corpId?: string): Promise<string> {
  if (!isInDingTalk()) throw new Error('当前不在钉钉内，无法免登')
  const dd = await waitForDD()
  return new Promise((resolve, reject) => {
    dd.runtime.permission.requestAuthCode({
      corpId,
      onSuccess: (result) => resolve(result.code),
      onFail: (err) => reject(new Error(typeof err === 'string' ? err : JSON.stringify(err))),
    })
  })
}
